import { HowToMeasure1 } from '../how-to-measure-1';
import { HowToMeasure2 } from '../how-to-measure-2';
import { BibOverall } from './bib-overall';
import { Boots } from './boots';
import { CoverallSnowPants } from './coverall-snow-pants';
import { PvcWader } from './pvc-wader';
import { Shirts } from './shirts';
import { VestsJackets } from './vests-jackets';
import { Wader } from './wader';

export const Men = () => {
  return (
    <div className='mx-auto w-full max-w-[1400px] px-[16px] lg_px-0'>
      <Boots />

      <Wader />
      <PvcWader />
      <BibOverall />
      <CoverallSnowPants />
      <Shirts />
      <VestsJackets />

      <HowToMeasure1 />
      <HowToMeasure2 image='/contact-us/men-measure.png' />
    </div>
  );
};
